import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  CreatePurchasesQuoteItemSupplierModel,
  DeletePurchasesQuoteItemSupplierModel,
  SearchPurchasesQuoteItemSupplierModel,
} from '../../../models/purchase-quote-item-supplier.model'

@Injectable({
  providedIn: 'root',
})
export class PurchasesQuoteItemSupplierService {
  private baseUrl = environment.baseUrl
  private resource: string = 'FornecedorCotacaoItem'

  constructor(private httpClient: HttpClient) {}

  public createPurchasesQuoteItemSupplier(
    model: CreatePurchasesQuoteItemSupplierModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editPurchasesQuoteItemSupplier(
    model: any,
    // model: EditPurchasesQuoteItemSupplierModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit`,
      model,
    )
  }

  public deletePurchasesQuoteItemSupplier(
    model: DeletePurchasesQuoteItemSupplierModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete`,
      model,
    )
  }

  public getPurchasesQuoteItemSupplierById(
    id: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public listPagedPurchasesQuoteItemSupplier(
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public searchListPagedPurchasesQuoteItemSupplier(
    page: number,
    rows: number = 15,
    model: SearchPurchasesQuoteItemSupplierModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public listPurchasesQuoteItemSupplier(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall`,
    )
  }

  public searchListPurchasesQuoteItemSupplier(
    model: SearchPurchasesQuoteItemSupplierModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search`,
      model,
    )
  }

  public listPagedPurchasesQuoteItemSupplierByProposalItemId(
    idProposalItem: number,
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/item-proposta/${idProposalItem}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPurchasesQuoteItemSupplierByProposalItemId(
    idProposalItem: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall/item-proposta/${idProposalItem}`,
    )
  }

  public listPurchasesQuoteItemSupplierByPurchasesQuote(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall/cotacao`,
      model,
    )
  }

  public listPagedPurchasesQuoteItemSupplierByPurchasesQuote(
    page: number,
    rows: number = 15,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/cotacao?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }
}
